import { Input } from '@/components/ui/input';
import { useQualityConfigList } from '@/hooks/useQualityConfigs';

import type { RunQualityNodeData } from '@repo/shared-types';

interface Props {
  data: RunQualityNodeData;
  onChange: (data: RunQualityNodeData) => void;
}

export const RunQualityConfig = ({ data, onChange }: Props) => {
  const { data: configs } = useQualityConfigList();
  const update = (patch: Partial<RunQualityNodeData>) => onChange({ ...data, ...patch });

  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <label className="text-muted-foreground text-xs font-medium">Label</label>
        <Input
          value={data.label}
          onChange={(e) => update({ label: e.target.value })}
          placeholder="Quality"
        />
      </div>

      <div className="space-y-1">
        <label className="text-muted-foreground text-xs font-medium">Quality Config</label>
        <select
          value={data.qualityConfigId ?? ''}
          onChange={(e) => update({ qualityConfigId: e.target.value || undefined })}
          className="border-input bg-background w-full rounded-md border px-3 py-2 text-sm focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none"
        >
          <option value="">(Use default for this DB)</option>
          {(configs ?? []).map((c) => (
            <option key={c.id} value={c.id}>
              {c.name} {c.is_default ? '(default)' : ''}
            </option>
          ))}
        </select>
        <p className="text-muted-foreground text-[10px]">
          Quality assessment uses transcript + audio. Without an audio recording, audio-only fields
          (silence/audio glitches/accent) are null.
        </p>
      </div>

      <div className="space-y-1">
        <label className="text-muted-foreground text-xs font-medium">Output Key</label>
        <Input
          value={data.outputKey ?? 'quality'}
          onChange={(e) => update({ outputKey: e.target.value })}
          placeholder="quality"
          className="font-mono text-xs"
        />
        <p className="text-muted-foreground text-[10px]">
          Templates can read {`{{<outputKey>.flags.<key>}}`} or {`{{<outputKey>.data.<key>}}`}.
        </p>
      </div>
    </div>
  );
};
